/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getAllVillageStates, getAllVillageDistricts, getAllVillageTalukas, getVillageListPagination, manageVillage, resetVillage, resetVillageList } from '../actions/masterManagementAction';
import masterLabels from '../labels/master_en.json';
import commonLabels from '../../../common/labels/common_en.json'
import TablePagination from '../../../common/components/TablePagination';
import ConfirmationDialog from '../../../common/components/ConfirmationDialog';
import VillageForm from './VillageForm';
import { toastr } from 'react-redux-toastr';

const VillageList = () => {
  let rowPerPage = 10;
  const dispatch = useDispatch();
  let [addVillage, setAddVillage] = useState({ "Mode": false, "villageState": '', "villageDistrict": '', "villageTaluka": '', "villageCode": '', "villageName": '' });
  let [searchMode, setSearchMode] = useState(false);
  let [villageCode, setVillageCode] = useState('');
  let [villageName, setVillageName] = useState('');
  let [villagePincode, setVillagePincode] = useState('');
  let [villageArea, setVillageArea] = useState('');
  let [villageState, setVillageState] = useState(false);
  let [villageDistrict, setVillageDistrict] = useState(false);
  let [villageTaluka, setVillageTaluka] = useState(false);
  let [listCurrentPage, setListCurrentPage] = useState(0);
  let [showModal, setShowModal] = useState(false);
  let [deleteVillage, setDeleteVillage] = useState(0);

  useEffect(() => {
    dispatch(getAllVillageStates());
    dispatch(resetVillage());
    dispatch(resetVillageList());
    setVillageName('');
    // eslint-disable-next-line
  }, [])

  const inputRef = useRef();

  const onVillageStateChange = (e) => {
    dispatch(resetVillage());
    dispatch(resetVillageList());
    villageStateChange(e);
  }

  const villageStateChange = (e) => {
    let villageSelectedState = e.target.value;
    setVillageState(villageSelectedState);
    setVillageDistrict(false);
    setVillageTaluka(false);
    setVillageName('');
    dispatch(getAllVillageDistricts(villageSelectedState));
  }

  const onVillageDistrictChange = (e) => {
    let villageSelectedDistrict = e.target.value;
    dispatch(resetVillage());
    dispatch(resetVillageList());
    setVillageDistrict(villageSelectedDistrict);
    setVillageTaluka(false);
    setVillageName('');
    dispatch(getAllVillageTalukas(villageSelectedDistrict));
  }

  const onVillageTalukaChange = (e) => {
    let villageSelectedTaluka = e.target.value;
    let villageNameTemp = '';
    setVillageTaluka(villageSelectedTaluka);
    setVillageName('');
    dispatch(getVillageListPagination(0, rowPerPage, villageSelectedTaluka, villageNameTemp));
  }

  const searchData = (textToSearch) => {
    setSearchMode(Number(new Date()));
    villageState && villageDistrict && villageTaluka && dispatch(getVillageListPagination(0, rowPerPage, villageTaluka, textToSearch));
    ((!villageState) || (!villageDistrict) || (!villageTaluka)) && toastr.error(commonLabels.SEARCH_VALIDATION_ERROR);
  }

  const { villageStatesList, villageDistrictsList, villageTalukasList, villageList, villagePageNoCounter } = useSelector((state) => state.masterManagementReducer, shallowEqual);
  let tableCounter = villagePageNoCounter + 1;
  const manageVillageData = (id) => {
    setShowModal(true);
    setDeleteVillage(id);
  }

  const deleteVillageData = (id) => {
    setShowModal(false);
    let requestBody = { "village": { "code": id, "isDeleted": true } };
    let totalRecords = villageList.totalNumberOfRecords;
    let remainder = totalRecords % rowPerPage;
    if (remainder == 1) {
      listCurrentPage = listCurrentPage - 1;
    }
    setListCurrentPage(listCurrentPage);
    dispatch(manageVillage(requestBody, rowPerPage, listCurrentPage, villageTaluka, villageName));
  }

  const activeVillage = (id, isActive) => {
    let requestBody = { "village": { "code": id, "isActive": !isActive } };
    dispatch(manageVillage(requestBody, rowPerPage, listCurrentPage, villageTaluka, villageName));
  }
  return addVillage.Mode !== false ? (
    <div>
      <VillageForm
        addVillage={addVillage}
        setAddVillage={setAddVillage}
        setVillageState={setVillageState}
        setVillageDistrict={setVillageDistrict}
        setVillageTaluka={setVillageTaluka}
        villageCode={villageCode}
        villageName={villageName}
        villageState={villageState}
        villageTaluka={villageTaluka}
        villageArea={villageArea}
        villageDistrict={villageDistrict}
        setVillageCode={setVillageCode}
        setVillageName={setVillageName}
        villagePincode={villagePincode}
        setVillagePincode={setVillagePincode}
        setVillageArea={setVillageArea}
      />
    </div>
  ) : (
    <div className="border border-light w-100 px-4 py-4">
      <div className='form-group'>
        <div className='d-flex align-items-center gap-4'>
          <label className="font-weight-bold float-left">{masterLabels.villageList.States}<span className="redColor">*</span></label>
          <select
            className='form-control '
            name="villageState"
            onInput={onVillageStateChange}
            ref={inputRef}
            defaultValue={addVillage && addVillage.villageState}
          >
            <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
            {villageStatesList && villageStatesList.stateDtoList && villageStatesList.stateDtoList.length > 0 && villageStatesList.stateDtoList.map((element, index) =>
              <option key={index} value={element.code}>{element.name}</option>
            )}
          </select>
          <label className="font-weight-bold float-left">{masterLabels.villageList.Districts}<span className="redColor">*</span></label>
          <select
            className='form-control'
            name="villageDistrict"
            value={villageDistrict}
            onInput={onVillageDistrictChange}
            ref={inputRef}
            defaultValue={addVillage && addVillage.villageDistrict}
          >
            <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
            {villageDistrictsList && villageDistrictsList.districtList && villageDistrictsList.districtList.length > 0 && villageDistrictsList.districtList.map((element, index) =>
              <option key={index} value={element.code}>{element.name}</option>
            )}
          </select>
          <label className="font-weight-bold float-left">{masterLabels.villageList.Talukas}<span className="redColor">*</span></label>
          <select
            className='form-control '
            name="villageTaluka"
            value={villageTaluka}
            onInput={onVillageTalukaChange}
            ref={inputRef}
            defaultValue={addVillage && addVillage.villageTaluka}
          >
            <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
            {villageTalukasList && villageTalukasList.talukaDtoList && villageTalukasList.talukaDtoList.length > 0 && villageTalukasList.talukaDtoList.map((element, index) =>
              <option key={index} value={element.code}>{element.name}</option>
            )}
          </select>
          <div className='col-md-2'>
            <input
              type="text"
              className="form-control"
              name="villageName"
              value={villageName}
              placeholder={masterLabels.villageList.Search_Label}
              onChange={event => (setVillageName(event.target.value), setSearchMode(false))}
              maxLength="50"
            />
          </div>
          <button className='form-control  btn btn-primary custom_button  button_search  ' onClick={() => { searchData(villageName); }}><i className="fa fa-search" type="button" ></i></button>
          <button className='form-control  btn btn-primary custom_button   ' onClick={() => { setVillageName(''); setAddVillage({ "Mode": "Add" }) }}>
            {masterLabels.villageList.Add_Village}
          </button>
        </div>
      </div>
      <br />
      <div className='form-group'>
        {villageList && villageList.totalNumberOfRecords > 0 ?
          <div className='row'>
            <div className='col-md-12'>
              <table className="table table-bordered">
                <thead className="thead-light">
                  <tr>
                    {/* <th scope="col" className='w-10 text-center'>{masterLabels.villageList.No}</th> */}
                    <th scope="col" className='w-10 text-center'>{masterLabels.villageList.Village_Code}</th>
                    <th scope="col" className='w-20 text-left'>{masterLabels.villageList.Village_Name}</th>
                    <th scope="col" className='w-20 text-left'>{masterLabels.villageList.Village_GramPanchayat}</th>
                    <th scope="col" className='w-30 text-left'>{masterLabels.villageList.Village_Area}</th>
                    <th scope="col" className='w-10 text-center'>{masterLabels.villageList.Action}</th>
                  </tr>
                </thead>
                <tbody className='small'>
                  {villageList && villageList.villageList && villageList.villageList.map((element, index) => {
                    if (element) {
                      return (
                        <tr key={index}>
                          {/* <td className="w-10 word-break text-center">{tableCounter++}</td> */}
                          <td className="w-10 word-break text-center">{element.code}</td>
                          <td className="text-left">{element.name}</td>
                          <td className="text-left">{element.grampanchayat}</td>
                          <td className="text-left">{element.area}</td>
                          <td className="w-10 word-break text-center">
                            <i role="button" data-toggle="tooltip" title={commonLabels.BUTTON_EDIT} className='text-primary fa fa-edit' onClick={() => { setAddVillage({ "Mode": "Edit", "villageCode": element.code, "villageName": element.name, "villageState": villageState, "villageDistrict": villageDistrict, "villageTaluka": element.subdistrictcode, "villagePincode": element.pincode, "villageLevels": element.levels, "villageAdminBlock": element.adminblock, "villageGrampanchayat": element.grampanchayat, "villageUniquecode": element.uniquecode, "villageArea": element.area, "villageGrampanchayatCode": element.grampanchayatcode }); }}></i>
                            &nbsp;&nbsp;
                            <i role="button" data-toggle="tooltip" title={element.isActive ? commonLabels.BUTTON_INACTIVE : commonLabels.BUTTON_ACTIVE}
                              className={element.isActive === true ? "text-success fa fa-toggle-on" : "text-danger fa fa-toggle-off"} onClick={(e) => { activeVillage(element.code, element.isActive); }}></i>
                            &nbsp;&nbsp;
                            <i role="button" data-toggle="tooltip" title={commonLabels.BUTTON_DELETE} className='text-danger fa fa-trash' onClick={(e) => { manageVillageData(element.code); }}></i>
                          </td>
                        </tr>
                      )
                    }
                  })
                  }
                </tbody>
              </table>
              {villageList && villageState && villageDistrict && villageTaluka &&
                <TablePagination
                  paginationFor="village_list"
                  rowPerPage={rowPerPage}
                  setListCurrentPage={setListCurrentPage}
                  searchCode2={villageTaluka}
                  textToSearch={villageName}
                  searchMode={searchMode}
                  totalCount={villageList.totalNumberOfRecords}
                />
              }
            </div></div>
          :
          <div className='text-center'>
            <font className="text-danger">
              {villageState && villageDistrict && villageTaluka && commonLabels.NO_DATA_FOUND}
              {(!villageState || !villageDistrict || !villageTaluka) && masterLabels.villageList.Select_State_And_District_And_Taluka_To_Fetch_Result}
            </font>
          </div>}
      </div>
      {
        <ConfirmationDialog
          showModal={showModal}
          Title={commonLabels.CONFIRMATION_MODAL_TITLE}
          Message={commonLabels.CONFIRMATION_MESSAGE}
          setShowModal={setShowModal}
          deleteRecord={deleteVillageData}
          deletedId={deleteVillage}
          IsConfirmation={"true"}
        />
      }
    </div>
  );
}

export default VillageList;